<!-- layout -->
<template>
  <div>
    <div v-if="$route.name === 'about'" class="header-background" :style="{ backgroundColor: 'transparent' }">
    </div>
    <div class="menu" :style=" menuStyle"  id="myElement">
      <div class="container flex-sb">
        <ul class="menu-nav">
          <li class="menu-logo">
            <img class="menu-logo" src="../../../assets/images/components/logo.png" />
          </li>
          <li v-for="(item, index) in menus" :key="index">
            <a
              :href="item.router"
              :class="[ activeMenuIndex == index?'active':'noactive' ]"
              @click="setActiveMenu(index)"
            >{{ item.title }}</a>
          </li>
        </ul>
        <div>
          <div v-if="isLogin==0" @click="loginDialogVisible = true"><GSAPbutton>登录</GSAPbutton></div>
          <div v-if="isLogin==1" @click="loginoutDialogVisible=true"><GSAPbutton>退出登录</GSAPbutton></div>
        </div>
      </div>

      <!-- 登录 -->
      <div class="dialog">
        <el-dialog
          v-model="loginDialogVisible"
          :close-on-click-modal="false"
          width="500"
          align-center
          destroy-on-close
          class="logindialog"
        >
          <div class="dialogtile">登录</div>
          <div class="dialogtitle2">
            没有账号，去
            <span class="goregister">
              <span class="goregister-text" @click="GoRegister()">注册</span>
            </span>
          </div>
          <div class="form-title">电子邮箱</div>
          <div class="dialoginput">
            <el-input v-model="loginEmail" type="text" class="emailinput" placeholder />
          </div>
          <div class="form-title">输入密码</div>
          <div class="dialoginput">
            <el-input
              v-model="loginPwd"
              autocomplete="new-password"
              class="emailinput"
              type="password"
              show-password
            />
          </div>
          <div
            :class="[ loginEmail&&loginPwd != ''?'ConfirmBtn':'ConfirmBtn1' ]"
            class
            @click="ConfirmLogin()"
             @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @mousemove="handleMouseMove"  
      ref="button"
          >
     登录
        </div>

          <div class="goresetpwd" @click="GoReset()">忘记密码？</div>
        </el-dialog>
      </div>
      <!-- 注册 -->
      <div class="dialog">
        <el-dialog
          v-model="registerDialogVisible"
          :close-on-click-modal="false"
          destroy-on-close
          width="500"
          align-center
          class="logindialog"
        >
          <div class="dialogtile">创建账号</div>
          <div class="dialogtitle2">
            已经有账号了去
            <span class="goregister">
              <span class="goregister-text" @click="GoLogin()">登录</span>
            </span>
          </div>
          <div class="form-title">用户名</div>
          <div class="dialoginput">
            <el-input v-model="registername" class="emailinput" placeholder />
          </div>
          <div class="form-title">电子邮箱</div>
          <div class="dialoginput">
            <div class="codeBox">
              <el-input v-model="registerEmail" class="emailinput" placeholder />
              <button class="codebtn" @click="getcode()" >
                <div v-if="!countdown" >获取验证码</div>
                <span v-else>{{''+ timeLeft+'s' }}</span>
              </button>
            </div>
          </div>
          <div class="form-title">验证码</div>
          <div class="dialoginput">
            <el-input v-model="registercode" class="emailinput" placeholder />
          </div>
          <div class="form-title">输入密码</div>
          <div class="dialoginput">
            <el-input v-model="registerPwd" class="emailinput" type="password" show-password />
          </div>
          <!-- <div class="form-title">确认密码</div>
          <div class="dialoginput">
            <el-input v-model="registerPwd2" class="emailinput" type="password" show-password />
          </div> -->
          <div
            :class="[ registername&&registerEmail&&registercode&&registerPwd != ''?'ConfirmBtn':'ConfirmBtn1' ]"
            class
            @click="ConfirmRegister()"
            @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @mousemove="handleMouseMove"  
        ref="button"
          >注册</div>
        </el-dialog>
      </div>
      <!-- 忘记密码 -->
      <div class="dialog">
        <el-dialog
          v-model="resetDialogVisible"
          :close-on-click-modal="false"
          destroy-on-close
          width="500"
          align-center
          class="logindialog"
        >
          <div class="dialogtile">忘记密码</div>

          <div class="form-title">电子邮箱</div>
          <div class="dialoginput">
            <!-- <el-input v-model="resetEmail" class="emailinput" placeholder /> -->
            <div class="codeBox">
              <el-input v-model="resetEmail" class="emailinput" placeholder />
              <button class="codebtn" @click="getcode1()">
                <span v-if="!countdown">获取验证码</span>
                <span v-else>{{''+ timeLeft+'s' }}</span>
              </button>
            </div>
          </div>
          <div class="form-title">验证码</div>
          <div class="dialoginput">
            <el-input v-model="resetcode" class="emailinput" placeholder />
          </div>
          <div class="form-title">重置密码</div>
          <div class="dialoginput">
            <el-input v-model="resetPwd1" class="emailinput" type="password" show-password />
          </div>
          <!-- <div class="form-title">确认密码</div>
          <div class="dialoginput">
          <el-input v-model="resetPwd2" class="emailinput" type="password" show-password />
          </div> -->
          <div
            :class="[ resetEmail&&resetcode&&resetPwd1 != ''?'ConfirmBtn':'ConfirmBtn1' ]"
            class
            @click="ConfirmReset()"
          >重置</div>
        </el-dialog>
      </div>
      <!-- 退出登录 -->
      <div class>
        <el-dialog
          v-model="loginoutDialogVisible"
          class="loginoutDialog"
          title="退出登录"
          width="500"
          height="200px"
        >
          <span>你是否要退出登录？</span>
          <template #footer>
            <div class="dialog-footer">
              <button type="primary" @click="loginOut()" style="width: 90px; "    class="gsap-button"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
      @mousemove="handleMouseMove"  
      ref="button">确认</button>
            </div>
          </template>
        </el-dialog>
      </div>
    </div>

    <!--<div class="container bremb">{{ activeMenu }}</div>-->
  </div>
</template>

<script>
import {
  login,
  verification,
  register,
  updatecode,
  updatepwd,
  getCompanyList
} from "@/api/api.js";
import { ElMessage } from "element-plus";
import { getToken, setToken } from "@/utils/store";
import GSAPbutton from "@/utils/GSAPbutton.vue";
import { gsap } from "gsap";
export default {
  name: "MyMenu",
  components: {GSAPbutton},
  data() {
    return {
      enterAngle: 0, // 用来存储鼠标进入时的角度
      routesItem: [],
      activeMenuIndex: 0, // 当前激活菜单的索引
      activeMenu:"资管策略",
      menus: [
        { title: "资管策略", router: "/" },
        { title: "财经热点", router: "/news" },
        { title: "机构动态", router: "/dynamics" },
        { title: "联盟成员", router: "/member" },
        { title: "券商投诉", router: "/complaint" },
        { title: "合作咨询", router: "/contact" },
        {title: "关于我们", router: "/about"}
      ],
      seconds: 60,
      timer: null,
      countdown: false,
      loginDialogVisible: false, //登录
      registerDialogVisible: false, //注册
      resetDialogVisible: false, //忘记密码
      loginoutDialogVisible: false, //退出登录
      loginEmail: "", // 登录邮箱
      loginPwd: "", // 登录密码
      registerEmail: "",
      registername: "",
      registercode: "",
      registerPwd: "",
      registerPwd2:"",
      resetname: "",
      resetEmail: "",
      resetcode: "",
      resetPwd1: "",
      resetPwd2: "",
      isLogin: 0
    };
  },
  computed: {
        timeLeft() {
      return this.seconds < 10 ? "0" + this.seconds : this.seconds;
    },
    menuStyle() {
      return {
        // animation: this.$route.name === 'about' ? 'fadeToTransparent 2s forwards' : '',
        // background: this.$route.name === 'about' ? 'transparent' : 'linear-gradient( 135deg, #9BDCFF 0%, #2F80ED 100%)',
        position: 'relative',
        zIndex: 2
      };
    }
    
  },
  watch: {
    // isLogin(newValue, oldValue) {
    //   console.log(newValue);
    //   console.log(oldValue);
    // }
    
  },
  methods: {
    handleMouseEnter(event) {
      this.$nextTick(() => {
       const button = this.$refs.button;
       if (button) {
        const rect = button.getBoundingClientRect();
     // ... rest of your code
      const x = event.clientX - rect.left;
      const y = event.clientY - rect.top;
      const width = button.offsetWidth;
      const height = button.offsetHeight;

      // 计算鼠标进入按钮时的角度
      const angle = Math.atan2(y - height / 2, x - width / 2);
      this.enterAngle = (angle + Math.PI) / (2 * Math.PI); // 将角度转化为 0-1 的值

      // 将角度转换为 360 度，并使用 GSAP 动画填充颜色
      const angleDeg = this.enterAngle * 360;

      gsap.to(button, {
        background: `linear-gradient(${angleDeg}deg, white,#55A5FA)`, // 根据鼠标角度动态填充背景
        duration: 1.2,
        color:"#55A5FA",
        ease: "power2.out",
        backgroundSize: "200% 200%", // 扩大背景区域
        scaleX: 1.01,
        scaleY: 1.01,
       
      });
       }
     });
      // const button = this.$refs.button;
      
     
    },
    handleMouseLeave() {
      const button = this.$refs.button;
      
      // 使用 GSAP 动画让颜色沿着原来的路径退出
      gsap.to(button, {
        background: `linear-gradient(${this.enterAngle * 360}deg, #55A5FA, #55A5FA)`, // 沿着进入时的角度退出
        backgroundSize: "100% 100%", // 恢复背景大小
        color:"white",
        duration: 1.2,
        ease: "power2.out",
        scaleX: 1,
        scaleY: 1,
      });
    },
   

updateBackground() {
  const element = document.getElementById('myElement');
  // 检查当前路由名称
  const isAboutRoute = this.$route.name === 'about';
  
  if (isAboutRoute) {
  // 如果是 'about' 路由，从渐变过渡到透明
  let steps = 100; // 分解成100步来过渡
    let step = 0; // 开始于0
    
    // 设置初始渐变背景
    element.style.backgroundImage = 'linear-gradient(135deg, #9BDCFF 0%, #2F80ED 60%)';
    element.style.backgroundSize = '200% 100%'; // 使背景宽度是元素的两倍，以便于过渡
    
    function transitionToTransparent() {
      // 计算当前步骤的位置
      let progress = step / steps;
      // 从左到右移动渐变，并逐渐减少透明度
      let startColor = `rgba(155, 220, 255, ${1 - progress})`;
      let endColor = `rgba(47, 128, 237, ${1 - progress})`;
      element.style.backgroundImage = `linear-gradient(135deg, ${startColor} 0%, ${endColor} 60%)`;
      // 移动渐变背景
      element.style.backgroundPosition = `${progress * -200}% 0`;
      
      step++;
      
      if (step <= steps) {
        // 使用requestAnimationFrame来平滑过渡
        requestAnimationFrame(transitionToTransparent);
      } else {
        // 过渡完成后，设置为完全透明
        element.style.background = 'transparent';
      }
    }
    
    // 开始过渡
    transitionToTransparent();
  
  } else {
    // 否则，过渡到渐变，由左向右
    let steps = 100; // 分解成100步来过渡
    let step = 0; // 开始于0
    
    // 设置初始渐变背景
    element.style.backgroundImage = 'linear-gradient(135deg, #9BDCFF 0%, #2F80ED 60%)';
    element.style.backgroundSize = '200% 100%'; // 使背景宽度是元素的两倍，以便于过渡
    
    function transitionGradient() {
      // 计算当前步骤的位置
      let progress = step / steps;
      // 从左到右移动渐变
      element.style.backgroundPosition = `${progress * 200}% 0`;
      
      step++;
      
      if (step <= steps) {
        // 使用requestAnimationFrame来平滑过渡
        requestAnimationFrame(transitionGradient);
      }
    }
    
    // 开始过渡
    transitionGradient();
  }
},
    setActiveMenu(index) {
      this.activeMenuIndex = index;
      sessionStorage.setItem("activeMenu", index);
    },
    clearinput() {
      (this.loginEmail = ""),
        (this.loginPwd = ""), // 登录密码
        (this.registerEmail = ""),
        (this.registername = ""),
        (this.registercode = ""),
        (this.registerPwd = ""),
        (this.resetEmail = ""),
        (this.resetcode = ""),
        (this.resetPwd1 = ""),
        (this.resetPwd2 = "");
    },
    startCountdown() {
      this.countdown = true;
      this.timer = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else {
          
       
          this.clearCountdown();
        }
      }, 1000);
    },

    clearCountdown() {
      this.seconds=60
      this.countdown = false;
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    // 验证邮箱
    isValidEmail(value) {
      const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
      return emailPattern.test(value);
    },
    setActiveMenu(index) {
      this.activeMenuIndex = index;
      this.activeMenu=this.menus[index].title
      sessionStorage.setItem("activeMenu", index);
    },
    // 打开注册弹窗
    GoRegister() {
      this.clearCountdown();
      this.registerDialogVisible = true;
      this.loginDialogVisible = false;
    },
    // 打开忘记密码弹窗
    GoReset() { 
      this.clearCountdown();
      this.resetDialogVisible = true;
      this.loginDialogVisible = false;
    },
    // 打开登录弹窗
    GoLogin() {
      this.resetDialogVisible = false;
      this.registerDialogVisible = false;
      this.loginDialogVisible = true;
    },
    // 获取注册验证码
    getcode() {
      if (this.isValidEmail(this.registerEmail)) {
        verification({ email: this.registerEmail })
          .then(res => {
            this.startCountdown();
            ElMessage({
              message: res.message,
              type: "success"
            });
            
            // this.registerDialogVisible = false;
          })
          .catch(err => {});
      } else {
        ElMessage.error("邮箱地址不正确！");
      }
    },
    // 获取忘记密码验证码
    getcode1() {
      if (this.isValidEmail(this.resetEmail)) {
        updatecode({ email: this.resetEmail })
          .then(res => {
            this.startCountdown();
            ElMessage({
              message: res.message,
              type: "success"
            });
            // this.resetDialogVisible = false;
          })
          .catch(err => {});
      } else {
        ElMessage.error("邮箱地址不正确！");
      }
    },

    // 确认
    ConfirmLogin() {
      login({
        username: this.loginEmail,
        password: this.loginPwd
      })
        .then(res => {
          ElMessage({
            message: "登录成功！",
            type: "success"
          });
          
          setToken("token", res.access);
          setToken("refresh", res.refresh);
          this.loginDialogVisible = false;
          this.isLogin = 1;
          this.clearinput();
        })
        .catch(err => {
          if (err.status == 401) {
            ElMessage.error("请检查您输入的用户名或密码！");
          }
        });
    },
    ConfirmRegister() {
      register({
        email: this.registerEmail,
        username: this.registername,
        password: this.registerPwd,
        verification_code: this.registercode
      })
        .then(res => {
          ElMessage({
            message: res.message,
            type: "success"
          });
          this.clearinput();
        })
        .catch(err => {
          ElMessage.error(err.response.data.error);
        });
    },
    ConfirmReset() {
      updatepwd({
        email: this.resetEmail,
        verification_code: this.resetcode,
        new_password: this.resetPwd1,
        confirm_password: this.resetPwd1
      })
        .then(res => {
          ElMessage({
            message: res.message,
            type: "success"
          });
          this.clearinput();
          this.resetDialogVisible = false;
        })
        .catch(err => {
          ElMessage.error(err.response.data.error);
        });
    },
    // 退出登录
    loginOut() {
      setToken("token", "");
      setToken("refresh", "");
      this.isLogin = 0;
      this.loginoutDialogVisible = false;
    }
  },
  created() {},
  mounted() {
  
    this.$watch('$route.name', this.updateBackground.bind(this));
    let param = sessionStorage.getItem("activeMenu");
    if (param != "") {
      this.activeMenuIndex = param;
    } else {
      this.activeMenuIndex = 0;
    }
    const token = getToken("token");
    console.log(token);
    
    if (token != ""&&token!=null) {
      this.isLogin = 1;
    } else {
      this.isLogin = 0;
    }
    console.log(this.isLogin);
    
    
  }
  
};
</script>
<style lang='css'  >
@import "../style/menu.css";

/* 登录弹窗 */
/* 修改自动填充选项的列表样式 */
.autocomplete-input:focus-within::-webkit-auto-fill-avoid-area {
  background-color: transparent;
  color: #000;
}
.dialog .el-dialog__headerbtn .el-dialog__close {
  color: #555 !important;
}
.dialog .el-dialog {
  border-radius: 10px !important;
}
.dialog .el-dialog__body,
.dialog .el-dialog__footer {
  padding: 10px 48px;
  padding-bottom: 48px;
  box-sizing: border-box;
}
.dialog .el-input__wrapper {
  border-radius: 10px;
  outline: none;
  box-shadow: none !important;
}

/* .dialog .el-button:hover {
  background: #55a5fa;
  color: #ffffff;
  border: none;
  opacity: 0.8;
}  */
.header-background {
  background-image: url('../../../assets/images/components/base.png '); /* 设置背景图 */
  background-size: cover; /* 背景图覆盖整个容器 */
  background-position: center; /* 背景图居中 */
  height: 450px; /* 设置高度，根据需要调整 */
 width: 100%;
 position: absolute;
  margin-bottom: 170px;
  z-index: 1;
  
}
/* .gsap-button {
  width: 120px;
  height: 36px;
  background: #55A5FA; 
  border-radius: 2px;
  border: 2px solid transparent; 
  margin-left: 20px;
  color: white; 
  border: none;
  cursor: pointer; 
  
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.gsap-button:focus {
  outline: none;
} */
/* @keyframes fadeToTransparent {
  0% { background-color: #55A5FA; }
  50% { background-color: rgba(#88CCFF 0.8); } 
  100% { background-color: transparent; }
} */
/* @keyframes fadeToTransparentNo {
  0% { background-color: transparent; }
  50% { background-color:rgba(#88CCFF 0.8); }
  100% { background-color: #55A5FA; }
} */

/* @keyframes gradientColorChange {
  0% {
    background: transparent;
  }
  50% {
    background-position: 100% 0;   ;
  }
  100% {
    background-position: 100% 0;   ;;
  }
} */
</style>